import { DialogContent } from '@bessemercws/components/bui';
import styled from '@emotion/styled';

export const StyledDialogContent = styled(DialogContent)`
  .BuiRadioGroup-root {
    padding: 0.75rem 0 1.5rem;
  }

  .otherUsers-container {
    .section-header {
      margin-bottom: 0;
    }
  }
  .otherUsers-warning {
    margin-bottom: 1.5rem;
  }

  .dialogContent {
    margin-top: 5px;
  }
  .deliveryPreference {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .consent-text {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .radio-buttons {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .otherUsers-container {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .otherUsers-warning {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
`;
